import Api from './Api'

export default {
    getAssociatedApprovers() {
        return Api().get('/customer/allAssociatedApprovers')
    },
    getAllUsers() {
        return Api().get('/user/all')
    },
    updateCustomerApprover(customerIds, userId) {
        return Api().post('/customers/approver', {
            customerIds,
            userId
        })
    },
    addUser(name, email) {
        return Api().post ('/user', {
            name,
            email
        })
    },
    editUser(name, email, user_id) {
        return Api().patch('/user', {
            name,
            email,
            user_id
        })
    },
    deleteUser(email) {
        return Api().delete('/user', {
            data:  {
            email
            }
        })
    },
    deleteCustomer(customerId) {
        return Api().delete('/customer', {
            data:  {
            customerId
            }
        })
    }
}